import React, { lazy } from 'react';
import { ImageCarousel } from './ImageCarousel';
const headerImg = 'https://cdn.magicpatterns.com/uploads/uaUGkzVmfu1XBBRRgyaEYj/Gemini_Generated_Image_ngecyqngecyqngec.jpg';
const mariaImg = 'https://cdn.magicpatterns.com/uploads/k7g6FpRUuSKrLCADHAjb9X/Gemini_Generated_Image_z44sw3z44sw3z44s.jpg';
const carlosImg = 'https://cdn.magicpatterns.com/uploads/cStgJiSdGd5C1KqFVQNsz5/Gemini_Generated_Image_9iopex9iopex9iop.jpg';
const packImg = 'https://cdn.magicpatterns.com/uploads/2dpms949CPfzpAutERYGHf/Gemini_Generated_Image_wy7iszwy7iszwy7i.jpg';
const reviews = [{
  name: 'María Gómez',
  location: 'CDMX',
  text: '¡Las recetas me han cambiado la vida! Todo es tan fácil y delicioso.',
  img: mariaImg
}, {
  name: 'Carlos Pérez',
  location: 'Monterrey',
  text: 'Excelente producto. Mis cenas nunca fueron tan rápidas y sabrosas.',
  img: carlosImg
}];
export function TestimonialsSection() {
  return <section className="bg-white pt-[40px] pb-[40px] px-[15px] relative" data-id="element-240">
      <div className="max-w-[700px] mx-auto px-[15px]" data-id="element-241">
        <h2 className="text-[26px] text-center mb-6 leading-[1.2] font-bold text-black heading-underline" data-id="element-242">
          <strong data-id="element-243">¿Qué dicen nuestros usuarios?</strong> ❤️
        </h2>

        <div className="mb-[30px] mx-auto max-w-[400px] overflow-hidden rounded-xl" data-id="element-244">
          <img src={headerImg} alt="Reseñas de nuestros usuarios" className="w-full h-auto block" loading="lazy" data-id="element-245" />
        </div>

        <h2 className="text-[22px] text-center mb-[25px] leading-[1.2] font-bold text-black" data-id="element-246">
          MÁS DE 3,450 CLIENTES SATISFECHOS
          <span className="text-primary block mt-1" data-id="element-247">★★★★★</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-[20px] p-0 max-w-[600px] mx-auto" data-id="element-248">
          {reviews.map((review, idx) => <div key={idx} className="flex flex-col gap-0 p-0 overflow-hidden border border-[#eee] rounded-xl bg-white shadow-[0_4px_10px_rgba(0,0,0,0.05)]" data-id="element-249">
              <img src={review.img} className="w-full h-[200px] object-cover" alt={`Testimonio de ${review.name}`} loading="lazy" data-id="element-250" />
              <div className="p-[20px] text-left" data-id="element-251">
                <div className="font-bold text-[16px] text-black leading-tight" data-id="element-252">
                  {review.name}
                </div>
                <div className="text-[12px] text-gray mb-1" data-id="element-253">
                  {review.location}
                </div>
                <div className="text-accent text-[14px] my-1.5" data-id="element-254">★★★★★</div>
                <p className="m-0 text-[14px] leading-[1.6] text-dark-gray" data-id="element-255">
                  "
                  {review.text.split('fácil y delicioso').length > 1 ? <>
                      ¡Las recetas me han cambiado la vida! Todo es tan{' '}
                      <strong data-id="element-256">fácil y delicioso</strong>.
                    </> : <>
                      Excelente producto. Mis cenas nunca fueron tan{' '}
                      <strong data-id="element-257">rápidas y sabrosas</strong>.
                    </>}
                  "
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-258">
          <h2 className="text-[24px] text-center mb-6 leading-[1.2] font-bold text-black heading-underline" data-id="element-259">
            Mira el Pack Saludable por dentro 📲
          </h2>
          <div className="shadow-[0_8px_20px_rgba(0,0,0,0.08)] rounded-lg overflow-hidden inline-block max-w-[80%]" data-id="element-260">
            <img src={packImg} alt="Mira el Pack Saludable por dentro" className="max-w-full h-auto block mx-auto" loading="lazy" data-id="element-261" />
          </div>
        </div>
      </div>
    </section>;
}